import BaseApiAction from '@Actions/base-api-action';

export default class GetUserStats extends BaseApiAction {
    runAction() {
        super.invokeCloudFunction({
            name: 'stats-consistentMetrics-getUserStats',
            payload: {
                ...this.addFieldIfExists('user_ids', this._payload.user_ids),
                ...this.addFieldIfExists('limit', this._payload.limit),
                ...this.addFieldIfExists('offset', this._payload.offset),
                ...this.addFieldIfExists('stats', this._payload.stats),
                ...this.addFieldIfExists('from_date', this._payload.from_date),
                ...this.addFieldIfExists('to_date', this._payload.to_date),
                ...this.addFieldIfExists('period_type', this._payload.period_type),
                ...this.addFieldIfExists('play_position', this._payload.play_position),
                ...this.addFieldIfExists('game_mode', this._payload.game_mode),
                ...this.addFieldIfExists('session_type', this._payload.session_type),
                ...this.addFieldIfExists('is_completed', this._payload.is_completed),
                ...this.addFieldIfExists('group_by_period', this._payload.group_by_period?.toLocaleUpperCase()),
                ...this.addFieldIfExists('order_by', this._payload.order_by)
            },
        });
    }
}
